import { render, staticRenderFns } from "./ImageWA.vue?vue&type=template&id=740afd54"
import script from "./ImageWA.vue?vue&type=script&lang=ts"
export * from "./ImageWA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports